import * as Yup from 'yup';

export const QuestionSchema = Yup.object().shape({
  question: Yup.object().shape({
    needAttachment: Yup.boolean(),
    hasCorrectAnswer: Yup.boolean(),
    createOccurrence: Yup.boolean(),
    occurrenceSector: Yup.number().when('createOccurrence', {
      is: true,
      then: (schema) =>
        schema
          .required('Informe setor responsável')
          .typeError('Informe setor responsável')
          .transform((value, originalValue) => {
            const convertedValue = Number(value);
            return isNaN(convertedValue) ? undefined : convertedValue;
          }),
      otherwise: (schema) => schema.nullable(),
    }),
    occurrenceTrigger: Yup.boolean().when('createOccurrence', {
      is: true,
      then: (schema) =>
        schema
          .required('Informe o(s) gatilhos para ocorrência')
          .typeError('Informe o(s) gatilhos para ocorrência')
          .transform((value, originalValue) => {
            if (value === null) {
              return undefined;
            }
            return value;
          }),
    }),
    subQuestionTrigger: Yup.boolean().when('hasSubQuestion', {
      is: true,
      then: (schema) =>
        schema
          .required('Informe o(s) gatilhos para subpergunta')
          .typeError('Informe o(s) gatilhos para subpergunta')
          .transform((value, originalValue) => {
            if (value === null) {
              return undefined;
            }
            return value;
          }),
    }),
    active: Yup.boolean().required('Campo obrigatório'),
    questionDescription: Yup.string()
      .required('Informe a pergunta')
      .max(800, 'Máximo de 800 caracteres'),
    mediaId: Yup.number().when(['typeSlug', 'hasVideoFile'], {
      is: (type, hasVideoFile) =>
        type?.toLowerCase() === 'video_visualization' && !hasVideoFile,
      then: (schema) =>
        schema
          .required('Envie um vídeo para a pergunta')
          .typeError('Envie um vídeo para a pergunta'),
      otherwise: (schema) => schema.nullable(),
    }),
    answers: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.number(),
          order: Yup.number(),
          description: Yup.string()
            .required('Campo obrigatório')
            .max(255, 'Máximo de 255 caracteres'),
          isCorrect: Yup.boolean(),
          triggerOccurrence: Yup.boolean(),
          triggerSubquestion: Yup.boolean(),
        }),
      )
      .when(['typeSlug', 'hasCorrectAnswer'], {
        is: () => true,
        then: (schema) =>
          schema
          .test(
            'answers-minimum-by-type',
            'Informe no mínimo duas opções de resposta',
            function testAnswersMinimumByType(value) {
              const type = (this?.parent?.typeSlug || '').toLowerCase();
              if (type === 'multiple' || type === 'unique') {
                return (value?.length || 0) >= 2;
              }
              return true;
            }
          )
          .test(
            'correct-answer-by-type',
            'Selecione ao menos uma resposta correta',
            function testCorrectAnswerByType(value) {
              const type = (this?.parent?.typeSlug || '').toLowerCase();
              const hasCorrectAnswer = !!this?.parent?.hasCorrectAnswer;

              if (!hasCorrectAnswer) {
                return true;
              }

              const correctAnswersCount =
                value?.filter(item => item?.isCorrect)?.length || 0;

              if (type === 'multiple') {
                return correctAnswersCount >= 1;
              }

              if (type === 'unique' || type === 'logic') {
                if (correctAnswersCount > 1) {
                  return this.createError({
                    message: 'Para este tipo de pergunta, selecione apenas uma resposta correta',
                  });
                }
                return correctAnswersCount === 1;
              }

              return true;
            }
          ),
      }),
    hasSubQuestion: Yup.boolean(),
  }),

  questionType: Yup.object().shape({
    id: Yup.number().required('Tipo obrigatório'),
    name: Yup.string(),
  }),
  childQuestion: Yup.object().when('question.hasSubQuestion', {
    is: (hasSubQuestion) => hasSubQuestion,
    then: (schema) =>
      schema.shape({
        createOccurrence: Yup.boolean(),
        occurrenceTrigger: Yup.boolean().when('createOccurrence', {
          is: true,
          then: (innerSchema) =>
            innerSchema
              .required('Informe o(s) gatilhos para ocorrência')
              .typeError('Informe o(s) gatilhos para ocorrência')
              .transform((value, originalValue) => {
                if (value === null) {
                  return undefined;
                }
                return value;
              }),
        }),
        questionDescription: Yup.string()
          .required('Campo obrigatório')
          .max(500, 'Máximo de 500 caracteres'),
        answers: Yup.array().of(
          Yup.object().shape({
            id: Yup.number(),
            order: Yup.number(),
            description: Yup.string()
              .required('Campo obrigatório')
              .max(255, 'Máximo de 255 caracteres'),
            triggerOccurrence: Yup.boolean(),
          }),
        ),
        occurrenceSector: Yup.number().when('createOccurrence', {
          is: true,
          then: (innerSchema) =>
            innerSchema
              .required('Informe setor responsável')
              .typeError('Informe setor responsável')
              .transform((value, originalValue) => {
                const convertedValue = Number(value);
                return isNaN(convertedValue) ? undefined : convertedValue;
              }),
          otherwise: (innerSchema) => innerSchema.nullable(),
        }),
      }),
    otherwise: (schema) => schema,
  }),
  childQuestionType: Yup.object().when('question.hasSubQuestion', {
    is: true,
    then: (schema) =>
      schema
        .shape({
          id: Yup.number().required('Tipo obrigatório'),
          name: Yup.string(),
        })
        .required('Tipo obrigatório'),

    otherwise: (schema) => schema.strip(),
  }),
});
